<mat-label class="subHeading">Cubic Capacity<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="cc" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="8" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="8" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="
        ccForm.controls['from'].hasError('small')
        ||
        ccForm.controls['to'].hasError('small')
    "
>
Invalid range for values
</p>
